// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal {
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.178);
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  pointer-events: none;
  transition: 0.5s;
  z-index: 5000;
}
.modal.active {
  opacity: 1;
  pointer-events: all;
}
.modal__content {
  padding: 20px;
  box-sizing: content-box;
  border-radius: 2px;
  background-color: white;
  transform: scale(0.5);
  transition: 0.4s all;
  position: relative;
  margin: 5em;
  height: min-content;
  text-align: left;
  display: flex;
  flex-direction: column;
  overflow: auto;
  align-items: center;
  justify-content: center;
}
.modal__content.active {
  transform: scale(1);
}

.modal-form__container {
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.474);
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  transition: 0.5s;
  z-index: 100;
  opacity: 1;
  pointer-events: all;
}

.modal_form {
  box-sizing: content-box;
  border-radius: 2px;
  background-color: #f5f5f5;
  max-width: 90vw;
  position: relative;
  margin: 5em;
  text-align: left;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 6000;
  min-height: 50%;
  max-height: 81%;
  border: 6px solid rgba(136, 166, 207, 0.2823529412);
  border-top: 1.9em solid rgba(136, 166, 207, 0.2823529412);
  border-radius: 1px 15px 1px 1px;
  box-sizing: content-box;
  position: absolute;
  box-shadow: rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px;
}
@media screen and (min-width: 1905px) {
  .modal_form {
    max-width: 1900px;
  }
}
.modal_form_label {
  position: absolute;
  top: -1.4em;
  left: 0;
  font-size: 1.1em;
  font-weight: 400;
  background-color: #f5f5f5;
  border-radius: 1px 25px 1px 0px;
  padding: 0 0.8em;
  line-height: 1.5em;
}
.modal_form .overflow_form_modal {
  width: 100%;
  height: 100%;
  overflow: auto;
  position: relative;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}
.modal_form__child {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  min-width: 850px;
  position: relative;
  height: 100%;
  overflow: visible;
  padding: 0 20px 20px 20px;
}

.modal_close_btn {
  top: -0.85em;
  right: 0.2em;
  position: absolute;
  border: 1px solid rgba(66, 108, 166, 0.368627451);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  background-color: aliceblue;
  font-size: 20px;
  line-height: 19px;
  font-weight: 300;
  margin-top: -5px;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/Components/Modal/modal.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,YAAA;EACA,sCAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EAEA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,oBAAA;EACA,gBAAA;EACA,aAAA;AAAF;AAEE;EACE,UAAA;EACA,mBAAA;AAAJ;AAEE;EACE,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,uBAAA;EAKA,qBAAA;EACA,oBAAA;EAWA,kBAAA;EACA,WAAA;EAGA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;AAhBJ;AAmBI;EACE,mBAAA;AAjBN;;AAsBA;EACE,aAAA;EACA,YAAA;EACA,sCAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EAEA,mBAAA;EACA,uBAAA;EAEA,oBAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;AArBF;;AAuBA;EACE,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EAIA,kBAAA;EACA,WAAA;EAEA,gBAAA;EACA,aAAA;EACA,sBAAA;EAEA,mBAAA;EAEA,aAAA;EAEA,eAAA;EACA,eAAA;EAGA,mDAAA;EACA,yDAAA;EACA,+BAAA;EAGA,uBAAA;EAEA,kBAAA;EAEA,+EAAA;AAjCF;AA8CE;EA7CF;IA8CI,iBAAA;EA3CF;AACF;AA6CE;EACE,kBAAA;EACA,WAAA;EACA,OAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,+BAAA;EACA,gBAAA;EACA,kBAAA;AA3CJ;AAmDE;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AAjDJ;AAoDE;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,yBAAA;AAlDJ;;AAuDA;EACE,YAAA;EACA,YAAA;EACA,kBAAA;EACA,iDAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AApDF","sourcesContent":[".modal {\n  height: 100vh;\n  width: 100vw;\n  background-color: rgba(0, 0, 0, 0.178);\n  position: fixed;\n  top: 0;\n  left: 0;\n  display: flex;\n  // padding-top: 10em;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  pointer-events: none;\n  transition: 0.5s;\n  z-index: 5000;\n\n  &.active {\n    opacity: 1;\n    pointer-events: all;\n  }\n  &__content {\n    padding: 20px;\n    box-sizing: content-box;\n    border-radius: 2px;\n    background-color: white;\n\n    // min-width: 550px;\n    // width: 100%;\n\n    transform: scale(0.5);\n    transition: 0.4s all;\n\n    // height: auto;\n    // height: ;\n    // min-height: 610px;\n    // max-height:70vh;\n    // overflow-y: scroll;\n    // overflow: hidden;\n    // overflow: scroll;\n\n    // max-height: 70vh;\n    position: relative;\n    margin: 5em;\n    // max-height: calc(100vh - 400px);\n\n    height: min-content;\n    text-align: left;\n    display: flex;\n    flex-direction: column;\n    overflow: auto;\n    align-items: center;\n    justify-content: center;\n    // min-width: max-content;\n    // max-height:max-content;\n    &.active {\n      transform: scale(1);\n    }\n  }\n}\n\n.modal-form__container {\n  height: 100vh;\n  width: 100vw;\n  background-color: rgba(0, 0, 0, 0.474);\n  position: fixed;\n  top: 0;\n  left: 0;\n  display: flex;\n  // padding-top: 10em;\n  align-items: center;\n  justify-content: center;\n  // opacity: 0;\n  pointer-events: none;\n  transition: 0.5s;\n  z-index: 100;\n  opacity: 1;\n  pointer-events: all;\n}\n.modal_form {\n  box-sizing: content-box;\n  border-radius: 2px;\n  background-color: #f5f5f5;\n  max-width: 90vw;\n\n  // transform: scale(0.5);\n  // transition: 0.4s all;\n  position: relative;\n  margin: 5em;\n  // height: min-content;\n  text-align: left;\n  display: flex;\n  flex-direction: column;\n  // overflow: auto;\n  align-items: center;\n  // justify-content: center;\n  z-index: 6000;\n  // height: 100%;\n  min-height: 50%;\n  max-height: 81%;\n  // max-width: 1900px;\n  // transform: translate(-50%, -50%);\n  border: 6px solid #88a6cf48;\n  border-top: 1.9em solid #88a6cf48;\n  border-radius: 1px 15px 1px 1px;\n  // min-width: 80vw;\n  // max-width: 1540px;\n  box-sizing: content-box;\n  // overflow-y: auto;\n  position: absolute; ////////////////////////////////////////////////////////////////////////////////////////////relative\n  // box-shadow: 0 4px 8px rgba(0, 0, 0, 0.5);\n  box-shadow: rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px;\n  // box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;\n\n  // @media screen and (min-width: 1024px) {\n  //   min-height: 50vh;\n  //   max-height: 80vh;\n  //   max-width: 1000px;\n  // }\n  // @media screen and (min-width: 1440px) {\n  //   min-height: 50vh;\n  //   max-height: 80vh;\n  //   max-width: 1240px;\n  // }\n  @media screen and (min-width: 1905px) {\n    max-width: 1900px;\n  }\n\n  &_label {\n    position: absolute;\n    top: -1.4em;\n    left: 0;\n    font-size: 1.1em;\n    font-weight: 400;\n    background-color: #f5f5f5;\n    border-radius: 1px 25px 1px 0px;\n    padding: 0 0.8em;\n    line-height: 1.5em;\n    // z-index: 10000;\n  }\n  // .fixed_button {\n  //   position: absolute;\n  //   right: 2em;\n  //   bottom: 1em;\n  // }\n  .overflow_form_modal {\n    width: 100%;\n    height: 100%;\n    overflow: auto;\n    position: relative;\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n  }\n\n  &__child {\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    width: 100%;\n    min-width: 850px;\n    position: relative;\n    height: 100%;\n    overflow: visible;\n    padding: 0 20px 20px 20px;\n    // padding: 0.5em 1.5em 0 1.5em;\n    // margin-top: 1em;\n  }\n}\n.modal_close_btn {\n  top: -0.85em;\n  right: 0.2em;\n  position: absolute;\n  border: 1px solid #426ca65e;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 20px;\n  height: 20px;\n  background-color: aliceblue;\n  font-size: 20px;\n  line-height: 19px;\n  font-weight: 300;\n  margin-top: -5px;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
